module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA3.2fc01dee.jpg";